import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus.ts'
import type { ILearningCourseRepository } from '@/core/domain/learning/course/ILearningCourseRepository.ts'
import type { LearningCourse } from '@/core/domain/learning/course/LearningCourse.ts'

export class UpdateLearningCourseStatusUseCase {
  private learningCourseRepository: ILearningCourseRepository

  constructor(learningCourseRepository: ILearningCourseRepository) {
    this.learningCourseRepository = learningCourseRepository
  }

  async execute(id: number, status: LearningStatus.Values): Promise<LearningCourse> {
    return await this.learningCourseRepository.updateLearningCourseStatus(id, status)
  }
}
